<script>
    import presets from './../../../presets/material-light';
    import AdaptersChart from "../../../component/adapters/Chart.vue";
    import ChartPrimeVue from 'primevue/chart';

    export default {
        props: {
            data: {
                type: Object,
                required: true
            },
            keysCount: {
                type: Number,
                required: true
            },
            top: {
                type: Number,
                required: false,
                default: 10
            },
            // Заголовок вместо «Топ N» — для данных без позиций (ИИ-ответы)
            title: {
                type: String,
                required: false,
                default: null
            }
        },
        data () {
            return {
                colors : presets.swatches,
                chartData: null,
                chartOptions: null
            }
        },
        methods: {
            setChartData() {
                this.chartData = {
                    datasets: [{
                        data: this.data.dataSets,
                        backgroundColor: this.colors,
                    }],
                    labels: this.data.labels,
                };
            },
            setChartOptions() {
                let self = this;
                this.chartOptions = {
                    plugins: {
                        title: {
                            display: true,
                            text: this.title ?? 'Топ ' + this.top
                        },
                        datalabels: {
                            formatter: (value) => {
                                return (value / (self.keysCount / 100)).toFixed(0) + '%';
                            },
                        },
                        legend: {
                            position: 'bottom',
                        },
                        hideAll: false,
                    },
                };
            },
        },
        computed: {
            getChartData() {
                return this.chartData;
            },
            getChartOptions() {
                return this.chartOptions;
            },
        },
        mounted() {
            this.setChartOptions();
            this.setChartData();
        },
        components: {
            AdaptersChart,
            ChartPrimeVue,
        }
    }
</script>

<template>
    <div class="canvas-con">
        <div class="canvas-con-inner">
            <AdaptersChart chart-type="doughnut" :chart-data="getChartData" :chart-options="getChartOptions" />
        </div>
    </div>
</template>

<style>
    .canvas-con {
        display: flex;
        align-items: center;
        justify-content: center;
        min-height: 300px;
        position: relative;
    }

    .canvas-con-inner {
        /*height: 100%;*/
    }

    .canvas-con-inner, .legend-con {
        display: inline-block;
    }

    .legend-con {
        display: inline-block;
        font-size: 12px;
        line-height: 20px;
    }
    .legend-con ul {
        list-style: none;
    }
    .legend-con li {
        display: flex;
        align-items: center;
        margin-bottom: 4px;
    }
    .legend-con li span {
        display: inline-block;
    }
    .legend-con li span.chart-legend {
        width: 10px;
        height: 10px;
        margin-right: 5px;
    }


</style>
